import { selectFeatureFlags } from 'core/userContext';
import { useQueryContext } from 'modules/billing/contexts/QueryContext';
import { useMetricInfo } from 'modules/billing/hooks/useMetricInfo';
import { useSelector } from 'react-redux';
import { AnalyticCard } from '../AnalyticCard';
import { ProjectBreakdownLink } from '../ProjectBreakdownLink';
import { USERS_CARD_IDS, USERS_CARD_TEXT, USERS_METRIC_NAMES } from './constants';

const {
  cardTitle,
  projectBreakdownUrl,
  activeUsersAddedInPeriodName,
  totalUsersAddedInPeriodName,
  totalUsersAddedInPeriodDescription,
  totalUsersAllTimeDescription,
  totalUsersAllTimeName,
  totalUsersHighWatermarkName,
  totalUsersHighWatermarkDescription,
} = USERS_CARD_TEXT;

export const UsersUsageCard = () => {
  const { isLoading } = useQueryContext();
  const { AllowActiveUsersMetricInBilling } = useSelector(selectFeatureFlags);

  const [
    totalUsersHighWatermarkInfo,
    totalUsersAllTimeInfo,
    totalUsersAddedInPeriodInfo,
    activeUsersAddedInPeriodInfo,
  ] = useMetricInfo(USERS_METRIC_NAMES);

  const cardMetricsBase = [
    {
      limit: totalUsersAllTimeInfo.annualLimit,
      metricDescription: `${totalUsersAllTimeDescription} ${totalUsersAllTimeInfo.lastAvailableDateText}`,
      metricName: totalUsersAllTimeName,
      metricValue: totalUsersAllTimeInfo.value,
      timePeriod: totalUsersAllTimeInfo.annualLimit
        ? 'maximum'
        : `As of ${totalUsersAllTimeInfo.lastAvailableDateText}`,
    },
    {
      limit: totalUsersHighWatermarkInfo.annualLimit,
      metricDescription: `${totalUsersHighWatermarkDescription} ${totalUsersHighWatermarkInfo.highWatermarkDateText}`,
      metricName: totalUsersHighWatermarkName,
      metricValue: totalUsersHighWatermarkInfo.value,
      timePeriod: totalUsersHighWatermarkInfo.annualLimit
        ? 'maximum'
        : totalUsersHighWatermarkInfo.dateRangeText,
    },
    {
      metricDescription: `${totalUsersAddedInPeriodDescription} ${totalUsersAddedInPeriodInfo.dateRangeText}`,
      metricName: totalUsersAddedInPeriodName,
      metricValue: totalUsersAddedInPeriodInfo.value,
      timePeriod: totalUsersAddedInPeriodInfo.dateRangeText,
    },
  ];

  const activeUsersAddedMetric = {
    metricName: activeUsersAddedInPeriodName,
    metricValue: activeUsersAddedInPeriodInfo.value,
    timePeriod: activeUsersAddedInPeriodInfo.dateRangeText,
  };

  const cardMetrics = AllowActiveUsersMetricInBilling
    ? [...cardMetricsBase, activeUsersAddedMetric]
    : cardMetricsBase;

  return (
    <AnalyticCard
      CardAction={<ProjectBreakdownLink to={projectBreakdownUrl} />}
      data-test={USERS_CARD_IDS.cardId}
      isLoading={isLoading}
      metrics={cardMetrics}
      title={cardTitle}
    />
  );
};
